import {
  Box,
  Divider,
  IconButton,
  TextField,
  Tooltip,
  Typography,
  Checkbox,
  FormControlLabel,
  Stack,
  CircularProgress,
  DialogTitle,
  Dialog,
  DialogContent,
  DialogContentText,
  Button,
  DialogActions,
  Avatar,
  Skeleton,
  InputAdornment
} from "@material-ui/core";
import { Close, Delete, Save, Search, Share } from "@material-ui/icons";
import { styled } from "@material-ui/styles";
import { useEffect, useRef, useState } from "react";
import axios from "axios";
import { REST_API_END_POINT } from 'src/constants/Defaultvalues';
import { useSnackbar } from "notistack";
import moment from "moment";
import html2canvas from "html2canvas";

const StickyNote = styled(Box)(({ theme, bgcolor }) => ({
  width: '100%',
  height: '100%',
  padding: '1em',
  fontSize: '14px',
  letterSpacing: '1px',
  position: 'relative',
  //   backgroundColor: '#FFE16A',
  backgroundColor: bgcolor || '#FFE16A',
  color: '#000',
  boxShadow: '0px 4px 10px rgba(0,0,0,0.3)',
  overflowWrap: 'break-word',
  fontFamily: `'Loved by the King', cursive`,
  borderRadius: '8px',
  margin: 'auto',

  '&::-webkit-scrollbar': {
    width: '6px',
  },
  '&::-webkit-scrollbar-thumb': {
    background: 'rgba(0, 0, 0, 0.2)',
    borderRadius: '10px',
  },
  '&::-webkit-scrollbar-track': {
    background: 'rgba(0, 0, 0, 0.05)',
  },
  '&::before': {
    content: '""',
    background: 'linear-gradient(135deg, rgba(255,255,255,0.9), rgba(255,255,255,0.7))',
    height: '40px',
    width: '30px',
    position: 'absolute',
    left: '50%',
    top: '-20px',
    transform: 'rotate(-3deg) translateX(-50%)',
    borderRadius: '4px',
  },
  '&::after': {
    content: '""',
    position: 'absolute',
    bottom: 0,
    right: 0,
    borderWidth: '10px 10px 10px 10px',
    borderStyle: 'solid',
    borderTopColor: '#DDC6C3',
    borderLeftColor: '#DDC6C3',
    borderBottomColor: '#5D576B',
    borderRightColor: '#5D576B',
  },
}));
const STICKY_COLORS = [
  '#FFE16A', // yellow
  '#FFD3B6', // peach
  '#FFAAA5', // light red
  '#D5AAFF', // lavender
  '#A0E7E5', // aqua
  '#B5EAD7', // mint
  '#C7CEEA', // periwinkle
  '#FFDAC1', // soft orange
  '#FF9AA2'  // pink
];

export default function NoteStickyIndividual({
  initialContent = "",
  noteId = null,
  onFullScreenClick,
  onRefresh,
  setOpenStickyDialog,
  userName,
  updatedOn,
  addedOn,
  updated_by_name,
  newNote,
  updatedName,
  initialPrivate = false,
  initialColor = null,
  isReadOnly = false,
  setOpenDelete = false,
  setSelectedId = '',
  fetchNotesL,
  onRefreshArchived,
  shareWith = [],
  note,
  isAdd, setIsAdd,
  unsavedChanges,
  setUnsavedChanges,
  onCloseDialog,
  isNew = false,
  // 🚀 LOADING STATE: Loading state props from parent
  setIsLoading,
  isLoading,
  startSaving,
  finishSaving,
}) {
  const [content, setContent] = useState(initialContent);
  const [isPrivate, setIsPrivate] = useState(initialPrivate);
  const [color] = useState(() => initialColor || STICKY_COLORS[Math.floor(Math.random() * STICKY_COLORS.length)]);
  const userSession = JSON.parse(localStorage.getItem('user'));
  const { enqueueSnackbar } = useSnackbar();
  const contentRef = useRef(null);
  const [noteHeight, setNoteHeight] = useState('auto');
  const [teamMembers, setTeamMembers] = useState([]);
  const [teamMembersLoading, setTeamMembersLoading] = useState(false);
  const isMountedRef = useRef(true);
  const [openShareDialog, setOpenShareDialog] = useState(false);

  // 🚀 CLEANUP: Prevent state updates on unmounted components
  useEffect(() => {
    return () => {
      isMountedRef.current = false;
    };
  }, []);
  const [selectedTeamMembers, setSelectedTeamMembers] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const originalSelectedMembersRef = useRef([]);
  const [isArchived, setIsArchived] = useState(note?.archive === 1 || false);
  const stickyRef = useRef(null);
  const [openDeleteForMeDialog, setOpenDeleteForMeDialog] = useState(false);
  const isEdit = noteId !== null && noteId !== undefined;

  useEffect(() => {
    const fetchTeamMembers = async () => {
      try {
        setTeamMembersLoading(true)
        const res = await axios.post(`${REST_API_END_POINT}tickets/get-all-team-members-sticky-notes`, {
          userId: userSession?.user_id,
          userType: userSession?.user_type,
        });
        setTeamMembers(res.data.teamData.data || []);
      } catch (error) {
        console.error("Failed to fetch team members", error);
      }
      finally {
        setTeamMembersLoading(false);
      }
    };

    fetchTeamMembers();
  }, []);


  useEffect(() => {
    if (contentRef.current) {
      const scrollHeight = contentRef.current.scrollHeight;
      const min = 70;
      const max = 400;
      const height = Math.min(Math.max(scrollHeight + 50, min), max);
      setNoteHeight(`${height}px`);
    }
  }, [content, isReadOnly]);

  useEffect(() => {
    setContent(initialContent || "");
    setIsPrivate(initialPrivate);
    // Initialize global flag for unsaved changes
    window.hasUnsavedStickyChanges = false;
    // if (shareWith && shareWith.length > 0) {
    //   const ids = shareWith.split(',').map(id => parseInt(id.trim()));
    //   setSelectedTeamMembers(ids);
    // }
    if (noteId && note?.share_with) {
      const ids = note.share_with.split(',').map(id => parseInt(id.trim()));
      setSelectedTeamMembers(ids);
      originalSelectedMembersRef.current = ids; // 🔐 Store original
    }

  }, [initialContent, initialPrivate, noteId, note]);

  // Auto-save when component unmounts or dialog closes with unsaved changes
  useEffect(() => {
    const handleAutoSave = async () => {
      console.log('Auto-save triggered:', { unsavedChanges, content: content?.trim(), noteId, note: note?.added_by, userSession: userSession?.user_id });
      if (unsavedChanges && content?.trim()) {
        try {
          // Auto-save when closing
          if (noteId && note?.added_by !== userSession?.user_id) {
            // For shared notes, use shared save
            console.log('Using shared save for note:', noteId);
            await handleSharedUserSave(true); // Show loading for auto-save
          } else {
            // For own notes (including new notes), use regular save
            console.log('Using regular save for note:', noteId || 'new note');
            await handleSaveSticky(true);
          }
        } catch (error) {
          console.error('Auto-save failed:', error);
        }
      }
    };

    // Listen for auto-save event
    window.addEventListener('autoSaveSticky', handleAutoSave);

    return () => {
      window.removeEventListener('autoSaveSticky', handleAutoSave);
    };
  }, [unsavedChanges, content, note, userSession, noteId]);

  const handleChange = (event) => {
    const value = event.target.value;
    setContent(value);
  
    // mark unsaved changes only when really needed
    if (!unsavedChanges) {
      setUnsavedChanges?.(true);
    }
    // Set global flag for popup component to check
    window.hasUnsavedStickyChanges = unsavedChanges || true;
  };
  

  const handleSaveSticky = async (makePrivate = true) => {
    if (!content?.trim()) {
      enqueueSnackbar('Please enter some content for the Sticky Note.', { variant: 'warning' });
      return;
    }

    try {
      document.activeElement.blur();
      const endpoint = isEdit ? 'edit-sticky-note-individual' : 'add-sticky-note-individual';
      const shareWith = selectedTeamMembers.length > 0 ? selectedTeamMembers.join(',') : ''
      
      console.log('Saving sticky note:', { isEdit, endpoint, noteId, content: content.trim() });
      
      // 🚀 LOADING STATE: Start loading
      if (isMountedRef.current && startSaving) {
        startSaving();
      }
      
      const payload = isEdit
        ? {
          id: noteId,
          sticky_note: content.trim(),
          updated_by: userSession?.user_id,
          is_private: makePrivate,
          color,
          share_with: shareWith
        }
        : {
          sticky_note: content.trim(),
          added_by: userSession?.user_id,
          is_private: makePrivate,
          color,
          share_with: shareWith
        };
      
      await axios.post(`${REST_API_END_POINT}tickets/${endpoint}`, payload);

      enqueueSnackbar(`Sticky Note${makePrivate ? '(s)' : ''} ${makePrivate ? 'saved' : 'shared'} successfully!`, { variant: 'success' });

      if (onRefresh) onRefresh(true);
      fetchNotesL()
      setOpenStickyDialog(false);
      setOpenShareDialog(false);
      if (!noteId) {
        setSelectedTeamMembers([]);
      }
      originalSelectedMembersRef.current = [...selectedTeamMembers];
      setSearchQuery('');
      if (setUnsavedChanges) {
        setUnsavedChanges(false);
      }
      // Reset global unsaved changes flag
      window.hasUnsavedStickyChanges = false;
    } catch (error) {
      console.error('Error saving sticky note:', error);
      enqueueSnackbar('Failed to save Sticky Note', { variant: 'error' });
    } finally {
      // 🚀 LOADING STATE: Stop loading
      if (isMountedRef.current && finishSaving) {
        finishSaving();
      }
      // Reset sharing flag
      window.sharingStickyNote = false;
    }
  };

  const handleDownloadAsImage = async () => {
    try {
      if (!stickyRef.current) {
        enqueueSnackbar("Sticky note element not found", { variant: "error" });
        return;
      }

      // 1️⃣  Clone the element we want to capture
      const original = stickyRef.current;
      const clone = original.cloneNode(true);
      document.body.appendChild(clone);

      /* ------------------------------------------------------------------
         Preserve line-breaks:
         html2canvas ignores the \n inside the <textarea> rendered by
         MUI’s TextField.  Replace that <textarea> with a <pre> that has
         the same content and styling, and give it white-space: pre-wrap.
      -------------------------------------------------------------------*/
      const ta = clone.querySelector("textarea");
      if (ta) {
        const pre = document.createElement("pre");
        pre.textContent = ta.value; // keep \n’s

        // Copy some of the textarea’s computed styles
        const cs = getComputedStyle(ta);
        Object.assign(pre.style, {
          fontFamily: cs.fontFamily,
          fontSize: cs.fontSize,
          lineHeight: cs.lineHeight,
          padding: cs.padding,
          margin: 0,
          whiteSpace: "pre-wrap"
        });

        ta.parentNode.replaceChild(pre, ta);
      }

      // 2️⃣  Move clone off-screen and size it exactly like the original
      const rect = original.getBoundingClientRect();
      clone.style.cssText += `
      position:absolute;
      top:-9999px;
      margin:0;
      width:${rect.width}px;
      height:${rect.height}px;
    `;
      clone.classList.add("exporting-image");

      // 3️⃣  Wait for fonts & styles, then render with html2canvas
      await document.fonts.ready;
      await new Promise((res) => setTimeout(res, 100)); // allow paint
      const canvas = await html2canvas(clone, {
        backgroundColor: null,
        useCORS: true,
        scale: 2
      });

      document.body.removeChild(clone); // cleanup the clone

      // 4️⃣  Convert to blob and offer download
      const blob = await new Promise((res) => canvas.toBlob(res, "image/png"));
      if (!blob) {
        enqueueSnackbar("Failed to render image", { variant: "error" });
        return;
      }

      if ("showSaveFilePicker" in window) {
        const fileHandle = await window.showSaveFilePicker({
          suggestedName: "sticky-note.png",
          types: [{ description: "PNG Image", accept: { "image/png": [".png"] } }]
        });
        const writable = await fileHandle.createWritable();
        await writable.write(blob);
        await writable.close();
      } else {
        const link = document.createElement("a");
        link.download = "sticky-note.png";
        link.href = URL.createObjectURL(blob);
        link.click();
      }
    } catch (err) {
      console.error("Download failed", err);
      enqueueSnackbar("Sticky note not downloaded", { variant: "error" });
    }
  };

  const handleSharedUserSave = async (showLoading = false) => {
    if (!content?.trim()) {
      enqueueSnackbar('Please enter some content to save.', { variant: 'warning' });
      return;
    }

    try {
      document.activeElement.blur();

      // 🚀 LOADING STATE: Start loading (only for auto-save)
      if (isMountedRef.current && startSaving && showLoading) {
        startSaving();
      }
      
      const payload = {
        id: noteId,
        sticky_note: content.trim(),
        updated_by: userSession?.user_id,
        share_with: originalSelectedMembersRef.current?.join(',') || null
      };

      await axios.post(`${REST_API_END_POINT}tickets/shared-save-sticky-notes`, payload);

      enqueueSnackbar('Note saved successfully!', { variant: 'success' });

      if (onRefresh) onRefresh(true);
      fetchNotesL();
      setOpenStickyDialog(false);
      if (setUnsavedChanges) {
        setUnsavedChanges(false);
      }
    } catch (error) {
      console.error('Error saving shared sticky note:', error);
      enqueueSnackbar('Failed to save Sticky Note', { variant: 'error' });
    } finally {
      // 🚀 LOADING STATE: Stop loading (only for auto-save)
      if (isMountedRef.current && finishSaving && showLoading) {
        finishSaving();
      }
    }
  };

  const handleArchiveToggle = async () => {
    try {
      // Set appropriate flag for loading message based on current state
      if (isArchived) {
        window.unarchivingStickyNote = true;
      } else {
        window.archivingStickyNote = true;
      }
      
      // 🚀 LOADING STATE: Start loading
      if (isMountedRef.current && startSaving) {
        startSaving();
      }

      await axios.post(`${REST_API_END_POINT}tickets/archive-unarchive-sticky-notes`, {
        id: noteId,
        updated_by: userSession?.user_id,
        archive: isArchived ? 0 : 1
      });

      // 🚀 IMMEDIATELY CLEAR LOADING STATE after API success
      if (isMountedRef.current && finishSaving) {
        finishSaving();
      }
      // Reset archive/unarchive flags immediately
      window.archivingStickyNote = false;
      window.unarchivingStickyNote = false;
      // Force clear loading state
      if (isMountedRef.current && setIsLoading) {
        setIsLoading(false);
      }

      enqueueSnackbar(`Note ${isArchived ? 'unarchived' : 'archived'} successfully`, { variant: 'success' });
      setIsArchived(!isArchived);

      // Clear any unsaved changes flag since archive/unarchive doesn't affect content
      if (setUnsavedChanges) {
        setUnsavedChanges(false);
      }
      window.hasUnsavedStickyChanges = false;

      if (onRefresh) onRefresh();
      if (onRefreshArchived) onRefreshArchived();
      if (fetchNotesL) fetchNotesL();

    } catch (err) {
      console.error("Archive/Unarchive failed", err);
      enqueueSnackbar("Failed to update archive status", { variant: "error" });
    } finally {
      // Only clear loading state in finally if not already cleared in success block
      // This is a safety net for error cases
      if (isMountedRef.current && setIsLoading) {
        setIsLoading(false);
      }
      // Ensure flags are reset
      window.archivingStickyNote = false;
      window.unarchivingStickyNote = false;
    }
  };

  const handleDeleteSticky = async (id) => {
    setSelectedId(id);
    setOpenDelete(true)
    //   try {
    //     await axios.post(`${REST_API_END_POINT}tickets/delete-sticky-note-individual`, {
    //       id,
    //       deleted_by: userSession?.user_id
    //     });
    //     enqueueSnackbar('Sticky Note deleted successfully', { variant: 'success' });
    //     if (onRefresh) onRefresh();
    //   } catch (error) {
    //     console.error('Delete error:', error);
    //     enqueueSnackbar('Failed to delete Sticky Note', { variant: 'error' });
    //   }
  };

  const handleShareClick = () => {
    setOpenShareDialog(true);
  };
  const handleShareClickClose = () => {
    setOpenShareDialog(false);
    if (noteId && note?.share_with) {
      setSelectedTeamMembers(originalSelectedMembersRef.current);
    } else {
      setSelectedTeamMembers([]); // only reset for new note
    }
    setSearchQuery('');
  };
  // const filteredTeamMembers = teamMembers.filter((member) =>
  //   `${member.first_name} ${member.last_name}`.toLowerCase().includes(searchQuery.toLowerCase())
  // );
  const filteredTeamMembers = [...teamMembers]
    .filter((member) =>
      `${member.first_name} ${member.last_name}`.toLowerCase().includes(searchQuery.toLowerCase())
    )
    // .sort((a, b) => {
    //   const aSelected = selectedTeamMembers.includes(a.id);
    //   const bSelected = selectedTeamMembers.includes(b.id);
    //   if (aSelected === bSelected) return 0;
    //   return aSelected ? -1 : 1; // selected goes to top
    //   // if (aSelected !== bSelected) return aSelected ? -1 : 1;
    //   // const nameA = `${a.first_name} ${a.last_name}`.toLowerCase();
    //   // const nameB = `${b.first_name} ${b.last_name}`.toLowerCase();
    //   // return nameA.localeCompare(nameB);
    // });
    .sort((a, b) => {
      const aId = Number(a.user_id);
      const bId = Number(b.user_id);
      const aSelected = selectedTeamMembers.includes(aId);
      const bSelected = selectedTeamMembers.includes(bId);

      // First, push selected ones on top
      if (aSelected && !bSelected) return -1;
      if (!aSelected && bSelected) return 1;

      // If both are selected, sort by their order in selectedTeamMembers
      if (aSelected && bSelected) {
        return selectedTeamMembers.indexOf(aId) - selectedTeamMembers.indexOf(bId);
      }

      // If neither are selected, sort alphabetically
      const nameA = `${a.first_name} ${a.last_name}`.trim().toLowerCase();
      const nameB = `${b.first_name} ${b.last_name}`.trim().toLowerCase();
      return nameA.localeCompare(nameB);
    })

  const handleDeleteForMe = async () => {
    try {
      const userId = userSession?.user_id;
      await axios.post(`${REST_API_END_POINT}tickets/delete-sticky-for-user`, {
        note_id: noteId,
        user_id: userId
      });
      enqueueSnackbar('Note removed from your view', { variant: 'success' });
      if (onRefresh) onRefresh(true);
      fetchNotesL();
      setOpenStickyDialog(false);
    } catch (err) {
      console.error("Failed to delete note for user", err);
      enqueueSnackbar("Failed to remove note", { variant: 'error' });
    }
  };

  return (
    <>
      <StickyNote
        ref={stickyRef}
        bgcolor={color}
        sx={{
          minHeight: '351px',
          position: 'relative',
          overflow: 'visible',
          borderRadius: '8px',

          ...(isNew && {
            outline: '2px solid rgba(47, 210, 25, 0.9)',
          
            boxShadow: `
              0 0 8px rgba(47, 210, 25, 0.9),
              0 0 18px rgba(47, 210, 25, 0.7),
              0 0 35px rgba(47, 210, 25, 0.45)
            `,
          
            animation: 'stickyNewGlow 1.8s ease-in-out infinite',
          
            '@keyframes stickyNewGlow': {
              '0%, 100%': {
                boxShadow: `
                  0 0 6px rgba(47, 210, 25, 0.7),
                  0 0 15px rgba(47, 210, 25, 0.5),
                  0 0 25px rgba(47, 210, 25, 0.3)
                `,
              },
          
              '50%': {
                boxShadow: `
                  0 0 12px rgba(47, 255, 25, 1),
                  0 0 30px rgba(47, 210, 25, 0.8),
                  0 0 50px rgba(47, 210, 25, 0.5)
                `,
              },
            },
          })
        }}
      >
        {isNew && (
          <Box
            className="exclude-from-image"
            sx={{
              position: 'absolute',
              top: 8,
              left: 8,
              zIndex: 2,
              bgcolor: '#1976d2',
              color: '#fff',
              px: 1,
              py: 0.25,
              borderRadius: 1,
              fontSize: 11,
              fontWeight: 700,
              fontFamily: 'sans-serif',
              letterSpacing: 0.5,
            }}
          >
            NEW
          </Box>
        )}
        <TextField
          fullWidth
          multiline
          minRows={10}
          variant="standard"
          onBlur={() => {
            if (contentRef.current) {
              const scrollHeight = contentRef.current.scrollHeight;
              const min = 70;
              const max = 400;
              setNoteHeight(`${Math.min(Math.max(scrollHeight + 50, min), max)}px`);
            }
          }}
          value={content}
          onChange={handleChange}
          placeholder="Write something....."
          disabled={isArchived}
          InputProps={{
            disableUnderline: true,
            style: {
              fontFamily: `'Loved by the King', cursive`,
              fontSize: '14px',
              color: '#000',
              padding: '12px',
              marginTop: '16px',
            },
            classes: {
              input: 'customInput',
            }
          }}
          sx={{
            //   height: '395px',
            height: noteHeight,
            overflowY: 'auto',
            '& .MuiInputBase-input.Mui-disabled': {
              WebkitTextFillColor: '#000', // ✅ keep black even if disabled
              opacity: 1, // ✅ prevent fade-out
            }
          }}
        />

        <Divider sx={{ pr: 3, pl: 3, mt: 1.8, borderColor: '#000' }} />
        {
          !isAdd && note?.added_by !== userSession?.user_id && (
            <Stack direction="row" className="sticky-controls exclude-from-image" spacing={1} sx={{
              mt: 1, ml: 1,
              justifyContent: 'flex-end',
              width: '100%'
            }}>
              <Tooltip title="Save Changes" placement="top" arrow>
                <IconButton
                  onClick={() => handleSharedUserSave(false)} // Don't show loading for manual save
                  sx={{
                    backgroundColor: '#FF9800',
                    color: '#fff',
                    '&:hover': {
                      backgroundColor: '#F57C00',
                    },
                  }}
                >
                  <Save fontSize="small" />
                </IconButton>
              </Tooltip>
              <Tooltip title="Delete for Me" placement="top" arrow>
                <IconButton
                  onClick={() => setOpenDeleteForMeDialog(true)}
                  sx={{
                    backgroundColor: '#E91E63',
                    color: '#fff',
                    '&:hover': { backgroundColor: '#C2185B' },
                  }}
                >
                  <Delete fontSize="small" />
                </IconButton>
              </Tooltip>
              <Dialog open={openDeleteForMeDialog} onClose={() => setOpenDeleteForMeDialog(false)}>
                <DialogTitle>Delete Confirmation</DialogTitle>
                <DialogContent>
                  <DialogContentText>
                    Are you sure you want to remove this note from your view?
                  </DialogContentText>
                </DialogContent>
                <DialogActions>
                  <Button variant="outlined" onClick={() => setOpenDeleteForMeDialog(false)} color="inherit">
                    Cancel
                  </Button>
                  <Button
                    variant="contained"
                    onClick={() => {
                      handleDeleteForMe();
                      setOpenDeleteForMeDialog(false);
                    }}
                    color="error"
                    startIcon={<Delete fontSize="small" />}
                  >
                    Delete for Me
                  </Button>
                </DialogActions>
              </Dialog>
            </Stack>
          )
        }
        {!isReadOnly && (
          <>
            {/* <FormControlLabel
          control={
            <Checkbox
              checked={isPrivate}
              onChange={(e) => setIsPrivate(e.target.checked)}
              color="primary"
            />
          }
          label="Private"
          sx={{ ml: 1, mt: 1 }}
        /> */}

            <Stack direction="row" className="sticky-controls exclude-from-image" spacing={1} sx={{
              mt: 1, ml: 1,
              justifyContent: 'flex-end',
              width: '100%'
            }}>
              {
                !isAdd &&

                <Tooltip title={isArchived ? 'Unarchive' : 'Archive'} placement="top" arrow>
                  <IconButton
                    onClick={handleArchiveToggle}
                    sx={{
                      backgroundColor: isArchived ? '#14B8A6' : '#7C3AED',
                      color: '#fff',
                      '&:hover': {
                        backgroundColor: isArchived ? '#0E8074' : '#5B21B6',
                      },
                    }}
                  >
                    <Stack className={isArchived ? 'material-symbols--unarchive-outline' : 'material-symbols--archive-outline'} />
                  </IconButton>
                </Tooltip>
              }

              {!isArchived && (
                <>
                  <Tooltip title="Share" placement="top" arrow>
                    <IconButton
                      onClick={handleShareClick}
                      sx={{ backgroundColor: '#2196F3', color: '#fff', '&:hover': { backgroundColor: '#1976D2' } }}>
                      <Share fontSize="small" />
                    </IconButton>
                  </Tooltip>

                  <Tooltip title="Save for me only" placement="top" arrow>
                    <IconButton
                      onClick={() => handleSaveSticky(true)}
                      sx={{
                        backgroundColor: '#4CAF50',
                        color: '#fff',
                        '&:hover': {
                          backgroundColor: '#388E3C',
                        },
                      }}
                    >
                      <Save fontSize="small" />
                    </IconButton>
                  </Tooltip>

                  {!newNote && (
                    <Tooltip title="Delete Note" placement="top" arrow>
                      <IconButton
                        onClick={() => handleDeleteSticky(noteId)}
                        sx={{
                          backgroundColor: '#f44336',
                          color: '#fff',
                          '&:hover': {
                            backgroundColor: '#d32f2f',
                          },
                        }}
                      >
                        <Delete fontSize="small" />
                      </IconButton>
                    </Tooltip>
                  )}

                </>
              )}
            </Stack>
            <Stack direction="row" className="sticky-controls exclude-from-image" spacing={1} sx={{
              mt: 1, ml: 1,
              justifyContent: 'flex-end',
              width: '100%'
            }}>
              <Box
                className="exclude-from-image"
                sx={{
                  position: 'absolute',
                  top: '8px',
                  right: '16px',
                  zIndex: 5,
                  backgroundColor: isPrivate ? '#ffcdd2' : '#c8e6c9',
                  color: '#000',
                  fontSize: '11px',
                  px: 1,
                  py: 0.2,
                  borderRadius: '6px',
                  fontWeight: 'bold',
                  fontFamily: `'Loved by the King', cursive`
                }}
              >
                <p>{isPrivate ? '🔒 Private' : '🌐 Public'}</p>
              </Box>
            </Stack>
          </>
        )}

        <Box
          className="sticky-controls exclude-from-image"
          onClick={handleDownloadAsImage}
          sx={{
            position: 'absolute',
            top: '8px',
            left: '10px',
            zIndex: 5,
            backgroundColor: '#FFE0B2',
            color: '#000',
            fontSize: '11px',
            px: 1,
            py: 0.2,
            borderRadius: '6px',
            fontWeight: 'bold',
            display: 'inline-flex',
            alignItems: 'center',
            gap: '6px',
            fontFamily: `'Loved by the King', cursive`,
            cursor: 'pointer',
            '&:hover': {
              opacity: 0.7,
              backgroundColor: '#FFD180',
            }
          }}
        >
          <Stack className={'line-md--download-loop'} /> Download Sticky Note
        </Box>


        {isReadOnly &&
          <Typography variant='body2' sx={{ fontFamily: `'Loved by the King', cursive`, fontSize: '12px', color: '#000', mt: 2, pl: '8px' }}>
            {/* {updatedName ? `Last edited by: ${updatedName}` : `Added by: ${userName}` || 'N/A'} */}
            {`Added by: ${userName}` || 'N/A'}
          </Typography>
        }

        <Typography variant='body2' sx={{ fontFamily: `'Loved by the King', cursive`, fontSize: '12px', color: '#000', mt: 1, pl: '8px' }}>
          {updatedOn
            ? `Updated on: ${moment.unix(updatedOn).format('MM-DD-YYYY hh:mm:ss A')}`
            : addedOn
              ? `Added on: ${moment.unix(addedOn).format('MM-DD-YYYY hh:mm:ss A')}`
              : 'N/A'}
        </Typography>
        {updatedName ? (<Typography variant='body2' sx={{ fontFamily: `'Loved by the King', cursive`, fontSize: '12px', color: '#000', mt: 1, pl: '8px' }}>
          Latest updated by: {updatedName ? updatedName : 'N/A'}
        </Typography>) : ''}
      </StickyNote>

      <Dialog open={openShareDialog} onClose={handleShareClick} maxWidth={false} PaperProps={{ sx: { width: 500 } }}>
        <DialogTitle>Share Sticky Note
          {/* {selectedTeamMembers.length > 0 && (
    <Typography
      variant="caption"
      sx={{ color: '#1976D2', fontWeight: 'bold', ml: 1 }}
    >
      ({selectedTeamMembers.length} selected)
    </Typography>
  )} */}
        </DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            fullWidth
            type="text"
            margin="dense"
            variant="outlined"
            label="Search team members..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Search />
                </InputAdornment>
              ),
              endAdornment: searchQuery && (
                <InputAdornment position="end">
                  <IconButton
                    size="small"
                    onClick={() => setSearchQuery('')}
                    edge="end"
                  >
                    <Close />
                  </IconButton>
                </InputAdornment>
              )
            }}
          />
          {selectedTeamMembers.length > 0 ? (
            <Typography
              variant="subtitle2"
              sx={{
                // color: '#1976D2', 
                // fontWeight: 'bold', mt: 1
              }}
              gutterBottom
            >
              {selectedTeamMembers.length} team member(s) selected
            </Typography>
          ) : (
            <Typography variant="subtitle2" gutterBottom>Select team members: </Typography>
          )}
          <Box sx={{ overflowY: 'auto', maxHeight: '280px', minHeight: '200px', overflowX: 'hidden', mt: 2, p: 1, minWidth: '400px' }}>
            {/* <Typography variant="subtitle2" gutterBottom>Select team members: </Typography> */}

            {teamMembersLoading ? (
              // <>
              //   <Typography variant="body2">Loading team members...</Typography>
              // </>
              Array.from({ length: 5 }).map((_, idx) => (
                <Box key={idx} sx={{ display: 'flex', alignItems: 'center', mb: 1, }}>
                  <Skeleton variant="circular" width={40} height={40} sx={{ mr: 2 }} />
                  <Skeleton variant="text" width="80%" height={30} />
                </Box>
              ))
            ) : filteredTeamMembers.length === 0 ? (
              <Typography variant="body2">No team members found.</Typography>
            ) : (
              filteredTeamMembers?.map((member) => (
                <FormControlLabel
                  key={member.id}
                  sx={{
                    width: '100%',
                    px: 1,
                    py: 0.5,
                    ml: 0,
                    mb: 0.5,
                    borderRadius: '6px',
                    '&:hover': {
                      backgroundColor: '#1ccaff',
                      '& .MuiCheckbox-root': {
                        color: '#ffffff', // ✅ white tick on hover
                      },
                    }
                  }}
                  control={
                    <Checkbox
                      checked={selectedTeamMembers.includes(member?.user_id)}
                      onChange={(e) => {
                        const checked = e.target.checked;
                        setSelectedTeamMembers((prev) =>
                          checked ? [...prev, member.user_id] : prev.filter((user_id) => user_id !== member.user_id)
                        );
                      }}

                      sx={{
                        '&.Mui-checked': {
                          color: 'primary.main',
                        },
                        '&:hover': {
                          '&.Mui-checked': {
                            color: '#ffffff'
                          },
                        }
                      }}
                    />
                  }
                  label={
                    <Typography sx={{ color: '#ffffff', fontSize: 14, display: 'inline-flex', alignItems: 'center' }}>
                      <Avatar src={member?.profile_pic} alt='Profile' sx={{ mr: 1 }} />{member.first_name} {member.last_name}
                    </Typography>
                  }
                />

              )))}
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleShareClickClose} variant="outlined" color="inherit">
            ❌ Cancel
          </Button>
          <Button onClick={async () => {
            if (selectedTeamMembers.length === 0) {
              enqueueSnackbar('Please select at least one team member to share.', { variant: 'warning' });
              return;
            }
            window.sharingStickyNote = true;
            handleSaveSticky(false);
          }}
            sx={{
              backgroundColor: '#2196F3',
              color: '#fff',
              '&:hover': {
                backgroundColor: '#1976D2'
              }
            }} variant="success" startIcon={<Share fontSize="small" />}>
            Share
          </Button>
        </DialogActions>
      </Dialog>

    </>
  );
}
